/** Seeded examples are not evidence that a user has activated the product. */
export function isRealApplication(application: { company: string; isDraft?: boolean }): boolean {
  return !application.company.startsWith('Demo:') && !application.isDraft
}

export function realApplicationCount(applications: ReadonlyArray<{ company: string; isDraft?: boolean }>): number {
  return applications.filter(isRealApplication).length
}
